var SolutionComments = React.createClass({
  getDefaultProps() {
    return {
      data: null,
      isGuest: false
    };
  },
  commentSaved(comment) {
    RA.ViewKB.Comments.load();
  },
  replySaved(comment) {
    RA.ViewKB.Comments.load(RA.ViewKB.Comments.currentPage);
  },
  reloadComments() {
    this.pageClicked(1);
  },
  pageClicked(pageNumber) {
    RA.ViewKB.Comments.load(pageNumber);
  },
  render() {
    let data = this.props.data;
    let inputForm, comments, pager, actions;

    if (!this.props.isGuest) {
      inputForm = <CommentBox onCommentSaved={this.commentSaved} />;
      actions =
        <div className="comments__actions">
          <SubscribeCommentsAction solutionID={RA.ViewKB.solution.id}
            defaultEmailAddress={RA.ViewKB.user.emailAddress} />
        </div>;
    } else {
		let redirTarget = (window.location.pathname + (window.location.search || "?") + "&guest=0").replace(/&/g, "_amp_");
		redirTarget = encodeURIComponent(redirTarget);
		let url = `${Config.contextPath}/${Config.portalInterface}/logout.jsp?redir=${redirTarget}`;
		let signUpUrl = `${Config.contextPath}/${Config.portalInterface}/logout.jsp?redir=${redirTarget}`;
		inputForm = <div className="comments__no-login-msg">{Labels.getLabel("Please")} <a href={url}>{Labels.getLabel("login")}</a> {Labels.getLabel("or")} <a href={signUpUrl}>{Labels.getLabel("sign up")}</a> {Labels.getLabel("to comment")}</div>
    }

    if (data && data.comments.length) {
      comments = (
        <div>
          <CommentsHead totalComments={data.totalComments} />
          <CommentsList comments={data.comments}
            showReplyLink={!this.props.isGuest}
            onReplySaved={this.replySaved}
            currentUserID={data.currentUserID}
            isResolutionAllowed={data.isResolutionAllowed}/>
        </div>
      );

      if (data.pagerDetail && data.pagerDetail.totalPages > 1) {
        pager = (
          <ResultsPager pagerDetail={data.pagerDetail}
            onPageClicked={this.pageClicked} />
        )
      }
    } else {
      comments = <span></span>;
    }

    return (
      <div>
        {actions}
        {inputForm}
        {comments}
        {pager}
      </div>
    );
  }
});